import { Box } from '@mui/material';
import { Switch, Route, useLocation } from 'react-router-dom';
import Step1 from '../scenes/CompanyOnboarding/step1';
import Step2 from '../scenes/CompanyOnboarding/step2';
import AdvisoryCloudLogo from '../components/AdvisoryCloudLogo';
import step3 from '../scenes/CompanyOnboarding/step3';
import step4 from '../scenes/CompanyOnboarding/step4';

function AOBFLayout() {
  const location = useLocation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 6,
        px: 2,
      }}
    >
      <Box sx={{ mb: 4 }}>
        <AdvisoryCloudLogo
          removeHyperlink
          onClick={() => {}}
          width={190}
          height={34}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          maxWidth:
            location.pathname === '/company/onboarding/step3' ? 'none' : 870,
        }}
      >
        <Switch>
          <Route exact path="/company/onboarding/step1" component={Step1} />
          <Route exact path="/company/onboarding/step2" component={Step2} />
          <Route exact path="/company/onboarding/step3" component={step3} />
          <Route exact path="/company/onboarding/step4" component={step4} />
        </Switch>
      </Box>
    </Box>
  );
}

export default AOBFLayout;
